/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Rail_Schedule_BodyInputs */

const en_platform_rail_schedule_body = /** @type {(inputs: Platform_Rail_Schedule_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set your hours once. Clients take the open times, series and reminders run themselves.`)
};

const pl_platform_rail_schedule_body = /** @type {(inputs: Platform_Rail_Schedule_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Godziny ustawiasz raz. Podopieczni biorą wolne terminy, serie i przypomnienia lecą same.`)
};

/**
* | output |
* | --- |
* | "Set your hours once. Clients take the open times, series and reminders run themselves." |
*
* @param {Platform_Rail_Schedule_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_rail_schedule_body = /** @type {((inputs?: Platform_Rail_Schedule_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Rail_Schedule_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_rail_schedule_body(inputs)
	return en_platform_rail_schedule_body(inputs)
});